/* TODO: t() */
/* eslint-disable @typescript-eslint/no-floating-promises */
import React, { useState } from 'react';
import { View, StyleSheet } from 'react-native';
import {
  Form,
  FormField,
  Label,
  Text,
  TextInput,
  SubmitButton,
  Alert,
} from '../uiold';

import { postJSON } from '../../support/Fetch';
import AdminModal from './AdminModal';
import { VendorAccount } from '../../types/shared/VendorAccount';

type Props = {
  email: string;
  marketAccountID: string;
  onLoginSuccess: (
    vendorAccount: VendorAccount,
    billingLink: string | undefined,
  ) => void;
  onHide: () => void;
  setEmail: (value: string) => void;
  displayResetModal: () => void;
};

export default function PasswordModal(props: Props) {
  const {
    email,
    marketAccountID,
    onLoginSuccess,
    onHide,
    setEmail,
    displayResetModal,
  } = props;

  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<null | string>(null);

  const errorDismiss = () => {
    setError(null);
  };

  const loginAttempt = () => {
    let reqData = {
      email,
      password,
      market: marketAccountID,
    };
    setIsLoading(true);
    postJSON('/api/vendor-auth', reqData, (error, data) => {
      if (error && error.status !== 401) {
        setError('Something went wrong');
      } else if (data.success) {
        const { account, token, billingLink } = data;
        onLoginSuccess({ ...account, token }, billingLink);
        setEmail('');
        onHide();
      } else {
        loginFail(data);
      }
    });
    setIsLoading(false);
  };

  const loginFail = (data: { error?: string; suspended?: boolean }) => {
    let { error } = data;
    setError(error ?? 'Login failed');
  };

  const renderError = () => {
    if (!error) {
      return null;
    }

    return (
      <Alert
        allowResize
        type="error"
        onDismiss={errorDismiss}
        style={styles.errorAlert}
        text={error}
      />
    );
  };

  return (
    <AdminModal title="Login" isLoading={isLoading} onClose={() => onHide()}>
      <Form onSubmit={loginAttempt} style={styles.alignStretch}>
        {error ? renderError() : null}
        <FormField
          render={(id) => (
            <View>
              <Label style={styles.textLabel} htmlFor={id}>
                Password:
              </Label>
              <TextInput
                id={id}
                style={styles.textInput}
                value={password}
                secureTextEntry
                onChangeText={(value) => setPassword(value)}
                autoFocus={true}
              />
            </View>
          )}
        />
        <View style={styles.buttonContainer}>
          <Text onPress={() => displayResetModal()}>Forgot Password?</Text>
          <SubmitButton title="Login" />
        </View>
      </Form>
    </AdminModal>
  );
}

let styles = StyleSheet.create({
  alignStretch: {
    alignSelf: 'stretch',
  },
  textLabel: {
    fontSize: 14,
    marginTop: 10,
  },
  textInput: {
    marginVertical: 5,
  },
  buttonContainer: {
    paddingVertical: 20,
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  errorAlert: {
    marginBottom: 10,
  },
});
